export default "__VITE_ASSET__Kfyoye7z__"